import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { featureResponseModel } from 'src/app/shared/models/response/feature-group-response';
import { Result } from 'src/app/shared/models/response/result';
import { FeatureGroupService } from 'src/app/shared/services/featuregroup.service';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { WebStorageService } from '../../services/web-storage.service';
import { ConfigResponseModel } from 'src/app/shared/models/response/client-config-response';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Constants } from 'src/app/shared/constants';
import {FeatureFlagService} from '../../services/feature-flag.service';
import { FeatureFlags } from 'src/app/shared/feature-flags';
import { PasswordExpiry } from 'src/app/shared/models/response/user-response-model';
import { AdminUserService } from 'src/app/admin/servicies/admin-user.service';
import { ResultOfT } from 'src/app/shared/models/response/result';


@Component({
    selector: 'app-therapist-header',
    templateUrl: './therapist-header.component.html',
    styleUrls: ['./therapist-header.component.sass'],
    standalone: false
})
export class TherapistHeaderComponent extends BaseComponent implements OnInit, OnDestroy {
  userfullname: string;
  features: featureResponseModel[];
  configResponseModel: ConfigResponseModel;
  imageUrl: SafeResourceUrl;
  imageData: string;
  imagealt: string;
  imageTitle: string;
  reminder:number = -1;
  passwordExpiryNotification:boolean = false; //(also in change-password.component.html )
  email:string;
  private unsubscriber = new Subject<boolean>();
  constructor(private authenticationService: AuthenticationService,
    private featureGroupService: FeatureGroupService,
    private webStorageService: WebStorageService,
    private sanitizer: DomSanitizer,
    messageService: MessageService,
    private userService: AdminUserService,
    private featureFlagService:FeatureFlagService) {
    super(messageService);
  }

  async ngOnInit() {

    this.configResponseModel = new ConfigResponseModel();
    this.configResponseModel = this.webStorageService.getClientConfig();
    if (this.configResponseModel) {
      this.imageData = Constants.imagePrefix + this.configResponseModel.companyLogo;
      this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.imageData);
      this.imagealt = this.configResponseModel.companyName;
      this.imageTitle = this.configResponseModel.companyName;
    }

    this.getFeatureGroups();
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    if (currentUserToken && currentUserAuthToken.token)
      this.userfullname = currentUserToken.userFullName;
    if (currentUserToken)
      this.email = currentUserToken.userEmail;

    await this.checkPasswordFeature(); 

   

  }

  private async getFeatureGroups() {
   
    await this.featureGroupService.getPermission()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .toPromise()
      .then((result) => {
        this.processResult<featureResponseModel[]>(result, () => {
          this.features = result.responseModel;
          this.webStorageService.deletePermissions();
          this.webStorageService.storePermissions(this.features);
        });
      });
  }


  onLogout() {
    this.authenticationService.signOut();
  }
  
  ngOnDestroy() {
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }
  }
  
  async checkPasswordFeature(){
    await this.featureFlagService.getFeatureFlag(FeatureFlags.PasswordExpiryNotification).subscribe(x=>{ 
      this.passwordExpiryNotification = x.responseModel.isEnabled;
      if (this.passwordExpiryNotification)
        this.IsPasswordExpired();
    });
  }
  private async IsPasswordExpired() {   
    const PwdExpiry = new PasswordExpiry();
    PwdExpiry.appUserEmail = this.email;
    
    await this.userService.IsPasswordExpired(PwdExpiry).
      pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<number>) => {
        this.processResult<number>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null && result.responseModel > 0) {
              this.reminder = result.responseModel;
            }
          }
        });

      }, (httpResponseError) => {        
        this.showErrorMessage(httpResponseError.message);
      });
     
  }
}
